<script>
export default {
    name: "BaseAward",
    props: {
        title: { type: String, default: "" }, // dari Title
        value: { type: String, default: "" }, // dari Desc, contoh: "2K+"
    },
    computed: {
        hasPlus() {
            return (this.value || "").endsWith("+");
        },
        baseText() {
            const v = this.value || "";
            return this.hasPlus ? v.slice(0, -1) : v;
        },
    },
};
</script>

<template>
    <div>
        <h2 class="text-[34px] font-medium text-nature-500 lg:mb-3">
            <span class="odometer">{{ baseText }}</span>
            <span v-if="hasPlus" class="text-primary">+</span>
        </h2>
        <p class="font-normal font-poppins text-nature-200 lg:text-lg">
            {{ title }}
        </p>
    </div>
</template>

<style scoped>
/* tambahkan styling odometer jika perlu */
</style>
